import React from 'react'

import numeral from 'numeral'

import {
  Icon,
  WalletIcon,
  ShoppingBasket,
  NotificationFilled,
  MailFilled,
  Upload,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  number,
  bool,
  string,
} from 'prop-types'

import BoostSales from './Icons/BoostSales'

function SvgNavbarIcon({
  indicator = 0,
  indicatorDisabled = false,
  disabled = false,
  type,
  className = '',
}) {
  function getIcon() {
    switch (type) {
      case 'wallet':
        return WalletIcon
      case 'cart':
        return ShoppingBasket
      case 'notification':
        return NotificationFilled
      case 'message':
        return MailFilled
      case 'upload':
        return Upload
      case 'boost-credits':
        return BoostSales
      default:
        return null
    }
  }

  const IconComponent = getIcon()

  if (IconComponent) {
    return (
      <div className={`${disabled ? 'is-disabled' : ''} ${className}`}>
        <Icon color="dark" notSpaced size="default" svgComponent={IconComponent} />
        {indicator > 0 && (
          <div
            className={`indicator ${indicatorDisabled && 'is-disabled'}`}
          >
            {numeral(indicator).format('0')}
          </div>
        )}
      </div>
    )
  }

  return null
}

SvgNavbarIcon.propTypes = {
  indicator: number,
  indicatorDisabled: bool,
  disabled: bool,
  type: string.isRequired,
  className: string,
}

export default SvgNavbarIcon
